/**
 * Barra do WordPress no celular: rola com a página (não fica presa no topo).
 *
 * Até 782px ela ocupa 46px — somada à topbar da escola, era um terço de
 * uma tela pequena parado. O CSS a deixa em position:absolute; aqui a
 * variável --lb-adminbar-h (no <body>) passa a valer quanto dela ainda
 * aparece (46px no topo, 0 depois de rolar), e a topbar/sidebar/gaveta usam
 * essa variável como `top` — sobem junto com a barra e grudam no topo.
 *
 * Área do aluno: _readylaunch-ajustes.scss · gestão: _theme.scss.
 */
(function () {
	const body = document.body;
	if (!body || !body.classList.contains('admin-bar')) return;

	const mq = window.matchMedia('(max-width: 782px)');
	let raf = 0;

	const atualiza = () => {
		raf = 0;
		if (!mq.matches) {
			body.style.removeProperty('--lb-adminbar-h');
			return;
		}
		const barra = document.getElementById('wpadminbar');
		const altura = barra ? barra.offsetHeight : 46;
		body.style.setProperty('--lb-adminbar-h', Math.max(0, altura - window.scrollY) + 'px');
	};

	const agenda = () => {
		if (!raf) raf = window.requestAnimationFrame(atualiza);
	};

	window.addEventListener('scroll', agenda, { passive: true });
	window.addEventListener('resize', agenda);
	if (mq.addEventListener) mq.addEventListener('change', agenda);
	atualiza();
})();
